export default __webpack_public_path__ + "static/media/fortis.ae2dfed9.png";